import type { ILoginLocale } from '@/Pages/Onboard/Login/Locale/Login.locale';

const ptBR: ILoginLocale = {
  title: 'Login no {brand}',
  email: {
    label: 'E-mail',
    placeholder: 'nome@grouplinkone.com',
    error: 'Por favor insira um endereço de email válido',
  },
  password: {
    label: 'Senha',
    placeholder: 'Sua senha',
    error: 'Senha é obrigatória',
  },
  button: {
    login: 'Entrar',
    forgotPassword: 'Esqueceu a senha?',
  },
  terms: {
    message1: 'Ao fazer login, você concorda com a nossa ',
    message2: '',
    terms: 'Termos de Serviço',
    privacy: 'Política de Privacidade',
  },
  errors: {
    invalidCredentials: 'E-mail ou senha inválidos',
    accountLocked: 'Sua conta foi bloqueada devido a múltiplas tentativas de login falhadas',
    accountDisabled: 'Sua conta foi desabilitada. Por favor entre em contato com o suporte',
    networkError: 'Erro de rede. Por favor verifique sua conexão e tente novamente',
    twoFactorRequired: 'Autenticação de dois fatores é necessária',
  },
};
export { ptBR };
